import type { TransitionProps } from 'vue'

const transition: TransitionProps = {
  onEnter(el, done) {
    const overlay = el.querySelector('#overlay')
    const backdrop = el.querySelector('#backdrop')

    if (!overlay) {
      done()
      return
    }

    // document.body.classList.add('has-overlay')
    if (backdrop) backdrop.style.pointerEvents = 'none'
    const { $gsap, $ScrollTrigger } = useNuxtApp()
    const isMobile = window.innerWidth < 900

    const content = overlay.querySelector('.translate-container')

    if (content) {
      $gsap.from(content, {
        yPercent: isMobile ? 50 : 0,
        xPercent: isMobile ? 0 : 50,
        // clipPath: 'inset(0% 0% 0 100%)',
        duration: 1.6,
        ease: 'power3.out',
      })

      $gsap.from(content, {
        opacity: 0,
        duration: 0.6,
        ease: 'power3.inOut',
      })
    }

    $gsap.from(overlay, {
      yPercent: isMobile ? 100 : 0,
      xPercent: isMobile ? 0 : 100,
      duration: 1.2,
      ease: 'power3.out',
      onComplete: () => {
        $ScrollTrigger.refresh()
        if (backdrop) backdrop.style.pointerEvents = 'auto'
        done()
      },
    })

    $gsap.fromTo(
      backdrop,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.inOut',
      },
    )
  },
  onLeave(el, done) {
    const overlay = el.querySelector('#overlay')
    const backdrop = el.querySelector('#backdrop')

    if (!overlay) {
      done()
      return
    }

    document.body.classList.remove('has-overlay')

    const { $gsap, $ScrollTrigger } = useNuxtApp()
    const isMobile = window.innerWidth < 900

    const content = overlay.querySelector('.translate-container')

    if (content) {
      $gsap.to(content, {
        yPercent: isMobile ? 100 : 0,
        xPercent: isMobile ? 0 : 100,
        duration: 0.6,
        ease: 'power2.in',
      })
    }

    $gsap.to(overlay, {
      yPercent: isMobile ? 100 : 0,
      xPercent: isMobile ? 0 : 100,

      duration: 0.8,
      ease: 'power2.inOut',
      onComplete: () => {
        $ScrollTrigger.refresh()
        done()
      },
    })

    $gsap.to(backdrop, {
      opacity: 0,
      duration: 0.6,
      ease: 'power2.inOut',
    })
  },
}

export default transition
